import React, { useState, useEffect, useRef  } from 'react';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import ShowError from "../shared/ShowError";
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import { InputText } from 'primereact/inputtext';


export default function CheckUserExistance(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const targetRef1 = useRef(null);
    const [mobile, setMobile] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [backUrl, setBackUrl] = useState("/get-company-detail");

    useEffect(() => {
        util.scrollToElement(targetRef1, "start");
        var osd = util.getOtherSystemDetail();
        setMobile(osd.mobile);
        setFirstname(osd.firstname);
        setLastname(osd.lastname);
        var buy = util.getBuy();
        if(buy.buyGoal == "buyService"){
            setBackUrl("/buy-service");
        }
    }, []);

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "mobile") setMobile(val);
        else if(name === "firstname") setFirstname(val);
        else if(name === "lastname") setLastname(val);
    }
    const checkDataEntry = function(){
        var check = util.IsMobileValid(mobile);
        if(!check.valid){
            setErorVisible(true);
            setErrorMessage(check.msg);
            return false;
        }
        return true;
    }
    const onContinueButtonClick = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {mobile:mobile, firstname:firstname, lastname:lastname};
        var url = config.Server+`/user/save-membership/immediatlly`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    var user = response;
                    console.log("response is>", response);
                    util.setCurrentUser(user);
                    setSaving(false);
                    if(props.onMembershipped)props.onMembershipped();
                    navigate("/buy/product/summary")
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
        
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}} ref={targetRef1}>
                
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate(backUrl)}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />   
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>عضویت در پرتال مشتریان هانا</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td>
                                        برای تکمیل فرایند خرید محصول و دسترسی به اطلاعات نصب و راه اندازی محصول، مشخصات زیر را تکمیل نمائید.
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                        {/* <div style={{width:"100%", paddingBottom:"10px"}}>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"30px"}}>
                                <Link to="/login" style={{textDecoration:"none", color:"rgb(85, 125, 244)"}}>حساب کاربری برای ورود به پرتال هانا دارم</Link>
                            </div>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"30px"}}>
                                <Link to="/reset-password" style={{textDecoration:"none", color:"rgb(85, 125, 244)"}}>کلمه عبور را فراموش کرده ام</Link>
                            </div>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"30px"}}>
                                <Link to="/request-membership" style={{textDecoration:"none", color:"rgb(85, 125, 244)"}}>ثبت نام</Link>
                            </div>
                        </div> */}
                        <div style={{width:"100%", paddingBottom:"10px"}}>
                            <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                                <tbody>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr>
                                        <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                            <FloatLabel>
                                                <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="nationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                                <label htmlFor="mobile">موبایل</label>
                                            </FloatLabel>                                            
                                        </td>
                                    </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={firstname} onChange={(e)=>{onInputChange(e, "firstname")}} id="firstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                    <label htmlFor="firstname">نام</label>
                                                </FloatLabel>                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                                <FloatLabel>
                                                    <InputText value={lastname} onChange={(e)=>{onInputChange(e, "lastname")}} id="lastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                    <label htmlFor="lastname">نام خانوادگی</label>
                                                </FloatLabel>                                                
                                            </td>
                                        </tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr><td>&nbsp;</td></tr>
                                        <tr>
                                            <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                                    <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;تائید مشخصات و ادامه&nbsp;&nbsp;</Button>
                                                </div>
                                            </td>
                                        </tr>

                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}